import {
  Req_GetTagList,
  Req_GetCustomerLevels
} from '@/request/customer'

export default {
  state: {
    tags: [],
    tagMap: {},
    cusLevels: [],
    activeCustomer: {},
    customerTypeList:[]
  },
  mutations: {
    updateTags(state,payload) {
      state.tags = payload
      payload.forEach(item => state.tagMap[item.id] = item )
    },
    initCusLevels(state,payload) {
      state.cusLevels = payload
    },
    onClientUpdateSuccess(state,payload) {
      state.activeCustomer = payload
    },
    initCustmerTypeList(state,payload) {
      console.log(payload)
      state.customerTypeList = payload
    }
  },
  actions: {
    getTagList(store) {
      Req_GetTagList().then(res => {
        store.commit('updateTags',res)
      }).catch(err => this.$catchErr(err))      
    },
    getCustomerLevels(store) {
      // Req_GetCustomerLevels().then(res => {
      //   store.commit('initCusLevels',res)
      // }).catch(err => this.$catchErr(err))
    },
    getCustomerTypeList(store) {
      const list = [
        {
          name:'工业',
          value:10
        },{
          name:'商业',
          value:20
        },{
          name:'服务业',
          value:30
        }
      ]
      store.commit('initCustmerTypeList',list)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/customer.js